// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";

const name = "multiScatteringPixelShader";
const shader = `#define RENDER_MULTI_SCATTERING
#define COMPUTE_MULTI_SCATTERING
#include<atmosphereUboDeclaration>
var transmittanceLutSampler: sampler;
var transmittanceLut: texture_2d<f32>;
#include<helperFunctions>
#include<atmosphereFunctions>
varying vUV: vec2f;
@fragment
fn main(input: FragmentInputs)->FragmentOutputs {fragmentOutputs.color=renderMultiScattering(input.vUV,transmittanceLut);}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("../ShadersWGSL/ShadersInclude/atmosphereUboDeclaration"),
    import("core/ShadersWGSL/ShadersInclude/helperFunctions"),
    import("../ShadersWGSL/ShadersInclude/atmosphereFunctions")
]));
/** @internal */
export const multiScatteringPixelShaderWGSL = { name, shader };
